import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class AccountBalance  {
    _originalTypeClassName = "zERP.BO.AccountBalance";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
AccountBalance.translate = translateService;
}
this.Debit = null;
this.Credit = null;
this.Account = null;
this.AccountBalanceKey = null;
this._key = this.AccountBalanceKey = 0; 
}

static translate: TranslateService;
_key: any;
Debit:any;
Credit:any;
Account:any;
private _AccountBalanceKey:any;
get AccountBalanceKey(): any {
    return this._AccountBalanceKey;
  }
set AccountBalanceKey(value: any) {
    this._AccountBalanceKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.AccountBalanceKey == null || $this.AccountBalanceKey == 0;
            }


}